import { contentString } from '../../utilities';
import { inspectorOther } from '../../SchedulingMap/mapIcons';
import { createCustomMarkerElement } from '../../createCustomMarkerElement';

export default async function makePins(todayIntakes, map) {
  
  const { AdvancedMarkerElement } = await window.google.maps.importLibrary("marker");

  const p = {};
  
  for (let e of todayIntakes) {
    const {
      id, 
      site: { siteRepEmail: email, siteRepName: contact, siteRepPhone: phone, geocode_results } = {}
    } = e.data;

    const {
      formatted_address,
      geometry: { location: position },
    } = geocode_results || { formatted_address: 'Assigned Project', geometry: { location: {} } };

    const marker = new AdvancedMarkerElement({
      position,
      title: formatted_address,
      map,
      content: createCustomMarkerElement(inspectorOther()), // Use 'content', not 'icon'
      // shape, 
    });

    const infoWindow = new window.google.maps.InfoWindow({
      content: contentString({ name: formatted_address, contact, phone, email }),
    });

    marker.addListener('click', () => {
      infoWindow.open({
        anchor: marker,
        map,
      });
    });

    p[id] = marker;
  }

  return p;
}